import { createSlice } from '@reduxjs/toolkit';

const initialState = { currentCaseId: 0, loaded: [] };

const haveLoadedInstance = (state, instance) => state.loaded.some((item) => item.caseId === instance.caseId);

function alterFieldInState(state, fieldName, newValue) {
  if (fieldName.endsWith('Date')) {
    newValue = newValue.toISO();
  }
  const caseId = state.currentCaseId;
  const currentCase = state.loaded.find((kase) => kase.caseId === caseId);
  const newCurrentCase = { ...currentCase, [fieldName]: newValue };
  const newLoaded = state.loaded.filter((kase) => kase.caseId !== caseId).concat(newCurrentCase);
  return { ...state, loaded: newLoaded };
}

export const casesSlice = createSlice({
  name: 'cases',
  initialState: initialState,
  reducers: {
    clearCases: () => {
      return initialState;
    },

    addCase: (state, action) => {
      const instance = action.payload;
      return haveLoadedInstance(state, instance) ? state : { ...state, loaded: state.loaded.concat(instance) };
    },

    setCurrentCase: (state, action) => {
      const kase = action.payload;
      const caseId = kase.caseId;
      const newLoadedCases = haveLoadedInstance(state, kase) ? state.loaded : state.loaded.concat(kase);
      return { ...state, currentCaseId: caseId, loaded: newLoadedCases };
    },

    updateCase: (state, action) => {
      const kase = action.payload;
      const caseId = kase.caseId;
      const otherCases = state.loaded.filter((c) => c.caseId !== caseId);
      const allCases = [kase].concat(otherCases);
      return { ...state, loaded: allCases };
    },

    changeCurrentCaseAdmissionDate: (state, action) => {
      return alterFieldInState(state, 'admissionDate', action.payload);
    },

    changeCurrentCaseDischargeDate: (state, action) => {
      return alterFieldInState(state, 'dischargeDate', action.payload);
    },

    changeCurrentCaseLeadTemperature: (state, action) => {
      return alterFieldInState(state, 'leadTemperature', action.payload);
    },

    changeCurrentCaseSalesStage: (state, action) => {
      return alterFieldInState(state, 'salesStage', action.payload);
    },

    changeCurrentCaseAdmissionOwner: (state, action) => {
      return alterFieldInState(state, 'admissionOwnerId', action.payload);
    },

    changeCurrentCasePrimaryClinician: (state, action) => {
      return alterFieldInState(state, 'primaryClinicianId', action.payload);
    },

    changeCurrentCaseTreatmentProgramIds: (state, action) => {
      return alterFieldInState(state, 'treatmentProgramIds', action.payload);
    },

    deleteCase: (state, action) => {
      const idOfCaseToDelete = action.payload;
      const newCaseId = idOfCaseToDelete === state.currentCaseId ? 0 : state.currentCaseId;
      const filteredCases = state.loaded.filter((c) => c.caseId !== idOfCaseToDelete);
      return { currentCaseId: newCaseId, loaded: filteredCases };
    },
  },
});

export const {
  clearCases,
  addCase,
  setCurrentCase,
  updateCase,
  changeCurrentCaseAdmissionDate,
  changeCurrentCaseDischargeDate,
  changeCurrentCaseLeadTemperature,
  changeCurrentCaseSalesStage,
  changeCurrentCaseAdmissionOwner,
  changeCurrentCasePrimaryClinician,
  changeCurrentCaseTreatmentProgramIds,
  deleteCase,
} = casesSlice.actions;

export default casesSlice.reducer;
